import React from 'react';
import { useSelector } from 'react-redux';
import { Button, Typography, ScreenContainer, ContentFrame, LayoutContent, LayoutControls, } from '@pinwheel/origami';
import useLinkNavigate from '../../hooks/useLinkNavigate';
import ModalHeader from '../../components/ModalHeader';
import { selectDdsResponse } from '../../state/slices/slice-link-api';
import { useOpts } from '../../context';
import { useAppDispatch } from '../../state';
import { setError } from '../../state/slices/slice-error';
import CardSwitchImage from '../../assets/card-switch-image.svg';
import { EventAction, EventType } from '../../types/events';
import { selectCurrentSource, selectLastSource, } from '../../state/slices/slice-segment';
import { useGetLocalizedString } from '../../hooks/useGetLocalizedString';
var CardSwitchConfirm = function () {
    var navigate = useLinkNavigate();
    var dispatch = useAppDispatch();
    var ddsResponse = useSelector(selectDdsResponse);
    var ddsOutcome = ddsResponse.responseType;
    var currentSource = useSelector(selectCurrentSource);
    var lastSource = useSelector(selectLastSource);
    var getLocalizedString = useGetLocalizedString();
    var _a = useOpts(), linkTokenPayload = _a.linkTokenPayload, loadedPlatform = _a.loadedPlatform, featureFlags = _a.featureFlags, exit = _a.exit, fireUnifiedEvent = _a.fireUnifiedEvent;
    var handleUseCard = function () {
        fireUnifiedEvent(EventType.LINK_POST_LOGIN_EVENT, {
            action: EventAction.TAP_CARD_SWITCH,
            entry_point: lastSource,
            source: currentSource,
        });
        navigate('/link-api/card-switch');
    };
    var handleNoCard = function () {
        fireUnifiedEvent(EventType.LINK_POST_LOGIN_EVENT, {
            action: EventAction.TAP_NO_THANKS,
            entry_point: lastSource,
            source: currentSource,
        });
        if (ddsOutcome === 'success') {
            if (featureFlags.skipSuccessOrErrorTerminalScreen)
                exit();
            else
                navigate('/success');
        }
        else if (ddsOutcome === 'pending_retry') {
            dispatch(setError({
                type: ddsResponse.error.type,
                code: ddsResponse.error.code,
                message: ddsResponse.error.message,
                pendingRetry: true,
            }));
            if (featureFlags.skipSuccessOrErrorTerminalScreen) {
                exit();
            }
            else {
                navigate('/error');
            }
        }
        else if (ddsResponse.responseType === 'error' ||
            ddsResponse.responseType === 'next_with_error') {
            dispatch(setError({
                type: ddsResponse.error.type,
                code: ddsResponse.error.code,
                message: ddsResponse.error.message,
                pendingRetry: false,
            }));
            if (ddsResponse.responseType === 'error') {
                if (featureFlags.skipSuccessOrErrorTerminalScreen) {
                    exit();
                }
                else {
                    navigate('/error');
                }
            }
        }
    };
    return (React.createElement(ScreenContainer, { "data-testid": "CardSwitchConfirm" },
        React.createElement(ModalHeader, null),
        React.createElement(ContentFrame, null,
            React.createElement(LayoutContent, null,
                React.createElement("div", { style: {
                        display: 'flex',
                        flex: 1,
                        alignItems: 'center',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        textAlign: 'center',
                    } },
                    React.createElement("img", { src: CardSwitchImage, alt: "Card" }),
                    React.createElement("div", { style: {
                            margin: '8px 0',
                        } },
                        React.createElement(Typography, { align: "center", variant: "header", weight: "bold", as: "h2" }, getLocalizedString('CARD_SWITCH_TITLE', [
                            linkTokenPayload.orgName,
                            loadedPlatform.name,
                        ]))),
                    React.createElement("div", { style: {
                            margin: '8px 0',
                        } },
                        React.createElement(Typography, { color: "light", align: "center", variant: "body", as: "h3" }, getLocalizedString('CARD_SWITCH_SUBTITLE', [
                            loadedPlatform.name,
                        ]))))),
            React.createElement(LayoutControls, null,
                React.createElement(Button, { eventId: "CardSwitch-begin", dataTestId: "button-continue", onClick: handleUseCard }, getLocalizedString('USE_CARD', [linkTokenPayload.orgName])),
                React.createElement(Button, { variant: "ghost", eventId: "CardSwitch-exit", dataTestId: "button-exit", onClick: handleNoCard }, "".concat(getLocalizedString('NO_THANKS')))))));
};
export default CardSwitchConfirm;
